// material-ui
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// project-imports
import SIDEBAR from '../sidebarStyles';

// ==============================|| DRAWER HEADER - STYLED ||============================== //

const DrawerHeaderStyled = styled(Box, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
  ...theme.mixins.toolbar,
  display: 'flex',
  alignItems: 'center',
  justifyContent: open ? 'flex-start' : 'center',
  paddingLeft: theme.spacing(open ? 2.5 : 0),
  borderBottom: `1px solid ${SIDEBAR.border}`,
  // Match the drawer background so the logo area is seamless with the navigation
  backgroundColor: SIDEBAR.bg
}));

export default DrawerHeaderStyled;
